module.exports = __webpack_public_path__ + "static/img/kf1.fc801b7a.png";